import Navbar from "./components/Navbar/Navbar";
import Landing from "./components/Landing/Landing";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact/Contact";
import Chatbot from "./components/Chatbot/Chatbot";
import "./App.css";

function App() {
  return (
    <div className="main-content">
      <Navbar />
      <Landing />
      <main>
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Contact />
      </main>
      <Chatbot />
    </div>
  );
}

export default App;